@if (url) {
  <img alt="" aria-hidden="true" [src]="url" style="position: absolute; width: 0; height: 0" loading="lazy" />
}
